import {useDispatch, useSelector} from 'react-redux';
import {
  getCurrentPageTableDataGrid,
  getDataTableDataGrid,
  getIsLoadingTableDataGrid,
  getPageSizeTableDataGrid,
  getRefreshTableDataGrid,
  getTitleTableDataGrid,
  getTotalTableDataGrid,
} from 'src/domain/app/redux/data-grid/data-grid-selectors';
import IntlMessages from 'src/domain/utility/IntlMessages';
import MainUtils from 'src/shared/utils/main';
import '../style.less';
import {Table} from '../../table';
import PaginationTable from '../../pagination';
import {
  setCurrentPageTableDataGrid,
  setPageSizeTableDataGrid,
  setRefreshTableDataGrid,
} from 'src/domain/app/redux/data-grid/data-grid-slice';
import type {TableColumnsType as ColumnsType, TableProps} from 'antd';
import Button from '../../button';
import {SyncOutlined} from '@ant-design/icons';

interface ITableDataGridProps {
  tableColumn?: any;
  tableProps?: TableProps<any>;
}

const TableDataGrid: React.FC<ITableDataGridProps> = (props) => {
  const {tableColumn, tableProps} = props;
  const titleTable = useSelector(getTitleTableDataGrid);
  const dataTable = useSelector(getDataTableDataGrid);
  const isTableLoading = useSelector(getIsLoadingTableDataGrid);
  const total = useSelector(getTotalTableDataGrid);
  const pageSize = useSelector(getPageSizeTableDataGrid);
  const currentPage = useSelector(getCurrentPageTableDataGrid);
  const refreshTable = useSelector(getRefreshTableDataGrid);

  const dispatch = useDispatch();

  return (
    <div className='table-container'>
      <div className='dg-table-head'>
        <h3 className='title-table'>
          {!MainUtils.isEmptyValue(titleTable) ? (
            <IntlMessages id={titleTable} />
          ) : (
            ''
          )}
        </h3>
        <Button
          className='refresh-btn'
          onClick={() => dispatch(setRefreshTableDataGrid(!refreshTable))}>
          <SyncOutlined spin={isTableLoading} className='refresh-icon' />
          <IntlMessages id='common.refresh' />
        </Button>
      </div>

      <Table
        dataSource={dataTable}
        columns={tableColumn as ColumnsType<any>}
        loading={isTableLoading}
        pagination={false}
        rowKey={(record) => record?.id?.toString()}
        {...tableProps}
      />

      <div className='dg-pagination-wrapper'>
        <PaginationTable
          total={total}
          pageSize={pageSize}
          currentPage={currentPage}
          showPageSizeOptions
          onChangePage={(data: any) => {
            dispatch(setCurrentPageTableDataGrid(data.page));
            dispatch(setPageSizeTableDataGrid(data.pageSize));
          }}
        />
      </div>
    </div>
  );
};

export default TableDataGrid;
